import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home'; // your home page
import NFCScanner from './NFCScanner'; // your NFC scan page
import RedirectPage from './RedirectPage';
import PrivacyPolicy from './PrivacyPolicy'; // Import the new component

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nfc-scan" element={<NFCScanner />} />
            <Route path="/redirect" element={<RedirectPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* Add the new route */}
        </Routes>
    );
};

export default AppRoutes;